// extracted by mini-css-extract-plugin
export default {"content":"styles_content__B3UMW","success":"styles_success__UhK6G","description":"styles_description__X97nD"};